import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: ReactNode;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Verificar se há usuário no localStorage (para funcionar sem backend)
  const localUser = localStorage.getItem('user');
  const localToken = localStorage.getItem('token');

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Carregando...</div>
      </div>
    );
  }

  // Se não há usuário no contexto nem no localStorage, redirecionar para login —
  // levando a localização atual junto, pra Login.tsx poder trazer o usuário de volta
  // pra cá depois (ex.: link de e-mail pra uma vaga específica).
  if (!user && !localUser && !localToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};